var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-container',{staticStyle:{"min-height":"100%"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Loading',{ref:"loading"}),_c('IdleWarningDialog',{ref:"idleWarning"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }